var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.999981C12 1.51056 11.5875 1.92306 11.0769 1.92306H0.923077C0.4125 1.92306 0 1.51056 0 0.999981C0 0.489404 0.4125 0.0769043 0.923077 0.0769043H11.0769C11.5875 0.0769043 12 0.489404 12 0.999981Z",
    fill: "#E53539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMinusIcon);
export default __webpack_public_path__ + "static/media/delete_minus_icon.9f349a685bb6c46f1306a2c75742925f.svg";
export { ForwardRef as ReactComponent };